var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { autoinject } from "aurelia-framework";
import { WorkflowAssignmentsService } from "../../../../services/workflow/workflow-assignments-service";
import { UserClientService } from "../../../../services/authentication/user-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { DialogServiceConstants } from "../../../../../../ClientApp/app/constants/basics/dialog.constants";
import { computedFrom } from "aurelia-binding";
var ActivityAssignment = /** @class */ (function (_super) {
    __extends(ActivityAssignment, _super);
    function ActivityAssignment(userClientService, notificationService, dialogClientService, i18N, workflowAssignmentsService, tokenClient) {
        var _this = _super.call(this, dialogClientService, i18N, workflowAssignmentsService) || this;
        _this.userClientService = userClientService;
        _this.notificationService = notificationService;
        _this.tokenClient = tokenClient;
        _this.filesToUploadKyc = [];
        _this.filesToUploadWinningStatement = [];
        _this.user = _this.userClientService.currentUser;
        return _this;
    }
    ActivityAssignment.prototype.onActivated = function () {
        var meta = JSON.parse(this.assignment.configMeta);
        this.isKycRequired = meta.isKycRequired;
        this.isWinnersStatementRequired = meta.isWinnersStatementRequired;
        if (this.assignment.meta) {
            var assignmentMeta = JSON.parse(this.assignment.meta);
            this.filePaths = assignmentMeta.files;
            this.fileWinnersStatementPaths = assignmentMeta.filesWinningStatement;
        }
        else {
            this.filePaths = [];
            this.fileWinnersStatementPaths = [];
        }
        if (this.filesToUploadKyc.length == 0)
            this.addFile();
        if (this.filesToUploadWinningStatement.length == 0)
            this.addWinningStatementFile();
        this.setAllowedFileFormats();
    };
    Object.defineProperty(ActivityAssignment.prototype, "acceptedFileTypes", {
        get: function () {
            return Enumerable.from(this.acceptedFileFormats).select(function (x) { return x.type; }).toArray().join(",");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityAssignment.prototype, "acceptedFileTitles", {
        get: function () {
            return Enumerable.from(this.acceptedFileFormats).select(function (x) { return x.title; }).toArray().join(", ");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityAssignment.prototype, "acceptedFileTitlesTranslationObj", {
        get: function () {
            return {
                'acceptedFileTitles': this.acceptedFileTitles
            };
        },
        enumerable: false,
        configurable: true
    });
    ActivityAssignment.prototype.setAllowedFileFormats = function () {
        this.acceptedFileFormats = [
            {
                "title": "*.pdf",
                "type": "application/pdf"
            },
            {
                "title": "*.doc",
                "type": "application/msword"
            },
            {
                "title": "*.docx",
                "type": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            },
            {
                "title": "*.odt",
                "type": "application/vnd.oasis.opendocument.text"
            },
            {
                "title": "*.txt",
                "type": "text/plain"
            },
            {
                "title": "*.rft",
                "type": "application/rtf"
            }
        ];
    };
    ActivityAssignment.prototype.addWinningStatementFile = function () {
        if (this.isWinnersStatementRequired) {
            this.filesToUploadWinningStatement.push({ file: "" });
        }
    };
    ActivityAssignment.prototype.addFile = function () {
        if (this.isKycRequired) {
            this.filesToUploadKyc.push({ file: "" });
        }
    };
    ActivityAssignment.prototype.accept = function () {
        var _this = this;
        if ((this.filesToUploadKyc.length == 0 || this.filesToUploadKyc.some(function (x) { return !x.file || x.file.length == 0; })) && this.isKycRequired) {
            this.notificationService.show("Error", "Kyc Document(s) is required", NotificationType.Error);
            return;
        }
        if ((this.filesToUploadWinningStatement.length == 0 || this.filesToUploadWinningStatement.some(function (x) { return !x.file || x.file.length == 0; })) && this.isWinnersStatementRequired) {
            this.notificationService.show("Error", "Winner's Statement is required", NotificationType.Error);
            return;
        }
        require("../../../../../../ClientApp/app/views/app/admin/dialogs/confirmation-dialog");
        var confirmModel = {
            headerTitle: "confirmation-title",
            headerMessage: "confirmation-accept-text",
            btnOkayText: "confirm-text",
            btnNoText: "cancel-text",
        };
        this.dialogClientService.show(DialogServiceConstants.URLs.ConfirmationDialog, {
            confirmModel: confirmModel,
            save: function () { return new Promise(function (resolve, reject) {
                var meta = {
                    files: Enumerable.from(_this.filesToUploadKyc).select(function (x) { return x.file; }).toArray(),
                    filesWinningStatement: Enumerable.from(_this.filesToUploadWinningStatement).select(function (x) { return x.file; }).toArray(),
                    gamePlayerId: _this.item.gamePlayerId
                };
                _this.assignment.meta = JSON.stringify(meta, null);
                _this.workflowAssignmentsService
                    .executeAction(_this.assignment.workflowStateId, 'brand-admin-activity', 'accept', _this.assignment.workflowAssignmentId, null, _this.assignment.remarks, _this.assignment.meta)
                    .then(function (response) {
                    _this.dialogClientService.hide();
                    _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("successfully-processed"), NotificationType.Success);
                    _this.reload(response.workflowState);
                    resolve();
                })
                    .catch(function () {
                    _this.dialogClientService.hide();
                    _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("error-while-processing-winning-claim-text"), NotificationType.Error);
                    reject();
                });
            }); },
        }, undefined, undefined, undefined, undefined, false);
    };
    ActivityAssignment.prototype.reject = function () {
        this.cancelWorkflow();
    };
    ActivityAssignment.prototype.getImagePath = function (imagePath) {
        var storageUri = this.tokenClient.storageUri;
        if (this.tokenClient.storageUri.endsWith('/')) {
            var substringed = this.tokenClient.storageUri.substr(0, this.tokenClient.storageUri.length - 1);
            storageUri = substringed;
        }
        var url = storageUri + imagePath;
        return url;
    };
    __decorate([
        computedFrom("acceptedFileFormats"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ActivityAssignment.prototype, "acceptedFileTypes", null);
    __decorate([
        computedFrom("acceptedFileFormats"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ActivityAssignment.prototype, "acceptedFileTitles", null);
    ActivityAssignment = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [UserClientService,
            NotificationClientService,
            DialogClientService,
            I18N,
            WorkflowAssignmentsService,
            TokenClient])
    ], ActivityAssignment);
    return ActivityAssignment;
}(BaseWorkflowActivityAssignmentViewModel));
export { ActivityAssignment };
